<template>
  <img
    src="../../images/logo.png"
    alt="EMB4Rs"
  />
</template>
